/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import { GET_LISTS, GET_LISTS_SUCCESS, GET_LISTS_FAIL } from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getLists() {
  yield takeEvery(GET_LISTS, function* (data) : any {
    try {
      const tagID = _.get(data, ['data', 'id']) || '1';
      const rowsPerPage = _.get(process.env.APP_CONFIG, ['APP_GLOBAL_CONFIG', 'ROWS_PER_PAGE'], '');
      const response = yield Request.get(`partner/TV/list/tagid/${tagID}/list_perpage/${rowsPerPage}/list_offset/${rowsPerPage * (_.get(data, ['data', 'page']) - 1)}`);
      if (_.get(response, ['data'])) {
        yield put({
          type: GET_LISTS_SUCCESS,
          data: {
            list_data: _.get(response, ['data']),
            list_info: _.get(response, ['meta']),
            hasNextPage: !!_.get(response, ['links', 'forward']),
          },
        });
      } else {
        yield put({ type: GET_LISTS_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_LISTS_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getLists),
  ]);
}
